import { render, staticRenderFns } from "./Tracks.vue?vue&type=template&id=4683b435"
var script = {}
import style0 from "./Tracks.vue?vue&type=style&index=0&id=4683b435&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports